export const APP_BASE_URL = 'https://intake.noorddigital.nl'

const MAIL_ENDPOINT = 'https://scan.noorddigital.nl/mail.php'

export async function submitIntake(
  htmlContent: string,
  markdownContent: string,
  clientEmail: string,
  clientName: string,
  attachments: File[] = [],
) {
  try {
    const formData = new FormData()
    formData.append('subject', `Nieuwe Website Intake – ${clientName}`)
    formData.append('email', clientEmail)
    formData.append('name', clientName)
    formData.append('html_body', htmlContent)
    formData.append('markdown_body', markdownContent)
    formData.append('to', 'info@noorddigital.nl')
    attachments.forEach((file) => {
      formData.append('attachments[]', file, file.name)
    })

    console.log('[Intake Submit]', {
      endpoint: MAIL_ENDPOINT,
      name: clientName,
      email: clientEmail,
      attachments: attachments.map((f) => `${f.name} (${f.size} bytes)`),
    })

    const response = await fetch(MAIL_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      body: formData,
    })

    if (!response.ok) {
      const errorText = await response.text()
      console.error('Server response:', response.status, errorText)
      throw new Error(
        `Server antwoordde met status ${response.status}: ${errorText || 'Geen details beschikbaar.'}`,
      )
    }

    await response.text()
    return { success: true }
  } catch (error) {
    console.error('Fout bij verzenden:', error)
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Onbekende fout bij verzenden.',
    }
  }
}
